// Converte um valor formatado em reais ("R$ 1.234,56") para centavos (123456).
export function parseValorCentavos(valor: string): number {
  const limpo = valor.replace(/[^\d,]/g, '');
  const [inteiro, centavos = ''] = limpo.split(',');
  const reais = parseInt(inteiro || '0', 10) || 0;
  const cents = centavos ? parseInt(centavos.padEnd(2, '0').slice(0, 2), 10) || 0 : 0;
  return reais * 100 + cents;
}

// Sempre exibe "R$ X,YY" (diferente de formatarValor, que vira "Gratuito" no zero).
export function formatarCentavos(centavos: number): string {
  const reais = Math.floor(centavos / 100);
  const cents = centavos % 100;
  return `R$ ${reais.toLocaleString('pt-BR')},${String(cents).padStart(2, '0')}`;
}

export function rotuloQuantidade(quantidade: number): string {
  return quantidade === 1 ? '1 ingresso' : `${quantidade} ingressos`;
}